module.exports = __webpack_public_path__ + "img/zhifubao.d30e4af2.jpg";